import { render, staticRenderFns } from "./FacetOption.vue?vue&type=template&id=642de3ab&scoped=true"
import script from "./FacetOption.vue?vue&type=script&lang=js"
export * from "./FacetOption.vue?vue&type=script&lang=js"
import style0 from "./FacetOption.vue?vue&type=style&index=0&id=642de3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642de3ab",
  null
  
)

export default component.exports